import { useApi } from '@backstage/core-plugin-api';
import { scmIntegrationsApiRef, scmAuthApiRef } from '@backstage/integration-react';
import React, { useState, useEffect, useCallback } from 'react';
import useDebounce from 'react-use/esm/useDebounce';
import { useTemplateSecrets } from '@backstage/plugin-scaffolder-react';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { BitbucketRepoBranchPicker } from './BitbucketRepoBranchPicker.esm.js';
import { DefaultRepoBranchPicker } from './DefaultRepoBranchPicker.esm.js';

const RepoBranchPicker = (props) => {
  const {
    uiSchema,
    onChange,
    rawErrors,
    formData,
    schema,
    formContext,
    required
  } = props;
  const {
    formData: { repoUrl }
  } = formContext;
  const [state, setState] = useState({
    branch: formData || ""
  });
  const { host, branch } = state;
  const integrationApi = useApi(scmIntegrationsApiRef);
  const scmAuthApi = useApi(scmAuthApiRef);
  const { secrets, setSecrets } = useTemplateSecrets();
  useDebounce(
    async () => {
      const { requestUserCredentials } = uiSchema?.["ui:options"] ?? {};
      if (!requestUserCredentials || !host) {
        return;
      }
      if (secrets[requestUserCredentials.secretsKey]) {
        return;
      }
      const { token } = await scmAuthApi.getCredentials({
        url: `https://${host}`,
        additionalScope: {
          repoWrite: true,
          customScopes: requestUserCredentials.additionalScopes
        }
      });
      setSecrets({ [requestUserCredentials.secretsKey]: token });
    },
    500,
    [host, uiSchema]
  );
  useEffect(() => {
    if (repoUrl) {
      const url = new URL(`https://${repoUrl}`);
      setState((prevState) => ({
        ...prevState,
        host: url.host,
        workspace: url.searchParams.get("workspace") || "",
        repository: url.searchParams.get("repo") || ""
      }));
    }
  }, [repoUrl]);
  useEffect(() => {
    onChange(branch);
  }, [branch, onChange]);
  const updateLocalState = useCallback(
    (newState) => {
      setState((prevState) => ({ ...prevState, ...newState }));
    },
    [setState]
  );
  const hostType = (host && integrationApi.byHost(host)?.type) ?? null;
  const renderRepoBranchPicker = () => {
    switch (hostType) {
      case "bitbucket":
        return /* @__PURE__ */ React.createElement(
          BitbucketRepoBranchPicker,
          {
            onChange: updateLocalState,
            state,
            rawErrors,
            accessToken: uiSchema?.["ui:options"]?.requestUserCredentials?.secretsKey && secrets[uiSchema["ui:options"].requestUserCredentials.secretsKey],
            required
          }
        );
      default:
        return /* @__PURE__ */ React.createElement(
          DefaultRepoBranchPicker,
          {
            onChange: updateLocalState,
            state,
            rawErrors,
            required
          }
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, schema.title && /* @__PURE__ */ React.createElement(Box, { my: 1 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, schema.title), /* @__PURE__ */ React.createElement(Divider, null)), schema.description && /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, schema.description), renderRepoBranchPicker());
};

export { RepoBranchPicker };
//# sourceMappingURL=RepoBranchPicker.esm.js.map
